import { type ReactElement } from 'react';
import {
  CarrierExclusionListsPage,
  type ExclusionListCarrier,
} from '@citibox-panel/lockers-operations';
import { UserMenu } from '@/features/user-menu';
import { resolveMarket, resolveMarketIndicator } from '@/lib/marketIndicator';
import { marketTimeZone } from '@/lib/marketTimeZone';
import { readRuntimeConfig } from '@/lib/runtimeConfig';
import { useSession } from '@/lib/session';
import { addExcludedUser, fetchExcludedUsers, removeExcludedUser } from '@/lib/apiClient';

// The carriers that have an exclusion list, mirroring app-service's catalog: Amazon alone today. A
// second carrier is one more line here — and a panel release, exactly as it is one in backend.
const CARRIERS: readonly ExclusionListCarrier[] = [{ slug: 'amazon', name: 'Amazon' }];

// Composition root for the exclusion-lists screen, exactly as AmazonDoorAccessRoute is for the gate:
// resolves the runtime config, picks the reads and writes, and keeps the module free of any
// apps/shell dependency.
export function CarrierExclusionListsRoute(): ReactElement {
  const { roleNames } = useSession();
  const config = readRuntimeConfig();
  const indicator = resolveMarketIndicator(config);

  return (
    <CarrierExclusionListsPage
      brandLabel={indicator.text}
      brandDegraded={indicator.degraded}
      headerEnd={<UserMenu roleNames={roleNames} />}
      carriers={CARRIERS}
      timeZone={marketTimeZone(resolveMarket(config))}
      fetchExcludedUsers={fetchExcludedUsers}
      addExcludedUser={addExcludedUser}
      removeExcludedUser={removeExcludedUser}
    />
  );
}
